import { useHistory } from 'react-router-dom'
import { push } from 'connected-react-router'

import { NON_VALID_ENTRY_PATHS } from '../constants/oauth'
import { ROOT } from '../constants/routes'

export const getHistoryParams = (history) => new Promise(resolve => {
    const { location } = history
    const searchParams = new URLSearchParams(location.search)
    const params = Object.fromEntries(searchParams.entries())
    resolve(params)
})

export const getHistoryFrom = (history) => {
    const { location } = history
    const { state } = location || {}
    const { from } = state || {}
    const { hash, pathname, search } = from || {}
    return {
        hash,
        pathname,
        search
    }
}

export const getHistoryFromUri = (history, ignore = {}) => {
    let uri = ''
    const { hash, pathname, search } = getHistoryFrom(history)
    if (!ignore.pathname) {
        uri = uri.concat(pathname || '/')
    }
    if (!ignore.search) {
        uri = uri.concat(search || '')
    }
    if (!ignore.hash) {
        uri = uri.concat(hash || '')
    }
    return uri
}

export const getEntryPageUrl = (history) => {
    const { location: { pathname, search, hash } } = history
    return { pathname, search, hash }
}

export const useCurrentPage = () => {
    const history = useHistory()
    const { location: { pathname } } = history
    switch (true) {
        case pathname.startsWith('/account'):
            return 'account'
        case pathname.startsWith('/connections'):
            return 'connections'
        case pathname.startsWith('/templates'):
            return 'templates'
        case pathname.startsWith('/workflows'):
            return 'workflows'
        default:
            return null
    }
}

export const setPath = (route, params) => {
    const paramsKeys = Object.keys(params || {})
    if (!paramsKeys.length) {
        return typeof route === 'string'
            ? route.replace(/[*|?]$/g, '')
            : route
    }
    let newRoute = route
    paramsKeys.forEach(p => {
        const regex = new RegExp(`:\\b${p}\\b`, 'g')
        newRoute = newRoute.replace(regex, params[p])
    })
    return newRoute.replace(/[*|?]$/g, '')
}

export const isPublicPath = (pathname = '') => {
    const publicPathList = [/\/(forms|dashboards)\/[\w|\d|-]{36}\/?/]
    try {
        return publicPathList.some(regExp => pathname.match(regExp))
    } catch {
        return false
    }
}

/**
 * Redirect the user to their entry page URL.
 *
 * @param {string} entryPageUrl - The entry page URL.
 * @param {Function} dispatch - The Redux dispatch function.
 */
export const redirectToEntryPage = (entryPageUrl, dispatch) => {
    try {
        if (!entryPageUrl || typeof entryPageUrl !== 'string') return
        const currentPathname = window.location.pathname
        const [, url] = entryPageUrl.split('sheetgo.com/')
        const [pathname, search] = url.split('?')
        const searchParams = new URLSearchParams(search || '')
        if (!pathname) {
            if (currentPathname === ROOT) return
            dispatch(push({
                pathname: ROOT,
                search: decodeURIComponent(searchParams.toString())
            }))
            return
        }
        const newPathname = !pathname.startsWith('/') ? `/${pathname}` : pathname
        if (NON_VALID_ENTRY_PATHS.some(p => p === newPathname)) {
            dispatch(push({
                pathname: newPathname,
                search: decodeURIComponent(searchParams.toString())
            }))
            return
        }
        if (currentPathname === newPathname) return
        dispatch(push({
            pathname: newPathname,
            search: decodeURIComponent(searchParams.toString())
        }))
    } catch { /** pass */ }
}

export default {
    redirectToEntryPage,
    getHistoryFromUri,
    getHistoryParams,
    getEntryPageUrl,
    getHistoryFrom,
    useCurrentPage,
    isPublicPath,
    setPath
}
